export { default } from "./useGuidedHighLightingTeacher";
